const groupItems = <K>(arr: K[], chunkSize: number): K[][] => {
  return arr.reduce((chunks: K[][], item: K, index: number) => {
    const chunk = Math.floor(index / chunkSize);
    chunks[chunk] = ([] as K[]).concat(chunks[chunk] || [], item);
    return chunks;
  }, []);
};

export { groupItems };
